import { useEffect } from 'react'

import { useEventTracker } from 'mmfintech-checkout-commons'
import { isNotEmptyString, tr } from 'mmfintech-commons'

import { Button } from 'mmfintech-portal-commons'
import { LabelValue } from '../../../components'
import { BankwirePreviewTitle, BankwirePreviewWrapper, WarningMessageWrapper } from './PreviewBankwire.styled'

export const PreviewBankwire = ({ result, session, sessionId }) => {
  const { successUrl } = session || {}

  const {
    recipientAddress,
    bankName,
    bankAddress,
    iban,
    bicSwift,
    bankCode,
    branchCode,
    accountNumber,
    accountOwner,
    bankCountryCode,
    accountType,
    // documentId,
    // documentType,
    reference
  } = result

  const { trackEvent } = useEventTracker()

  const handleRedirect = () => {
    trackEvent(sessionId, 'redirected_back_to_merchant')
    window.location.href = successUrl
  }

  // noinspection SpellCheckingInspection
  const formatAccountNumber = (): string | null =>
    accountNumber ? `${accountType === 'BANKGIRO' ? 'BG ' : ''}${accountNumber}` : null

  const getCountryCode = () => (bankCountryCode ? bankCountryCode : iban && iban.substring(0, 2) === 'GB' ? 'GBR' : '')

  useEffect(() => {
    trackEvent(sessionId, 'manual_bank_transfer_details_shown')
  }, [])

  return (
    <BankwirePreviewWrapper>
      <BankwirePreviewTitle data-test='bank-transfer-details'>
        {tr('CHECKOUT.DEPOSIT.PREVIEW.TITLE', 'Bank Transfer Details')}
      </BankwirePreviewTitle>

      <LabelValue label={tr('CHECKOUT.DEPOSIT.PREVIEW.BANK_NAME', 'Bank Name')} value={bankName} dataTest='bank-name' />
      <LabelValue
        label={tr('CHECKOUT.DEPOSIT.PREVIEW.BANK_ADDRESS', 'Bank Address')}
        value={bankAddress}
        dataTest='bank-address'
      />
      <LabelValue label={tr('CHECKOUT.DEPOSIT.PREVIEW.IBAN', 'IBAN')} value={iban} dataTest='iban' />
      <LabelValue label={tr('CHECKOUT.DEPOSIT.PREVIEW.BIC_SWIFT', 'BIC/SWIFT')} value={bicSwift} dataTest='bic-swift' />
      <LabelValue
        label={tr(
          `CHECKOUT.DEPOSIT.PREVIEW.BANK_NUMBER_${getCountryCode()}`,
          tr('CHECKOUT.DEPOSIT.PREVIEW.BANK_NUMBER', 'Bank Number')
        )}
        value={bankCode}
        dataTest='bank-number'
      />
      <LabelValue
        label={tr('CHECKOUT.DEPOSIT.PREVIEW.BRANCH_CODE', 'Branch code')}
        value={branchCode}
        dataTest='branch-code'
      />
      <LabelValue
        label={tr('CHECKOUT.DEPOSIT.PREVIEW.ACCOUNT_NUMBER', 'Account Number')}
        value={formatAccountNumber()}
        dataTest='account-number'
      />
      <LabelValue
        label={tr('CHECKOUT.DEPOSIT.PREVIEW.ACCOUNT_OWNER', 'Account Owner')}
        value={accountOwner}
        dataTest='account-owner'
      />
      <LabelValue
        label={tr('CHECKOUT.DEPOSIT.PREVIEW.OWNER_ADDRESS', 'Owner Address')}
        value={recipientAddress}
        dataTest='recipient-address'
      />
      <LabelValue
        label={tr('CHECKOUT.DEPOSIT.PREVIEW.REFERENCE', 'Reference')}
        value={reference}
        dataTest='reference'
      />

      {isNotEmptyString(reference) && (
        <WarningMessageWrapper>
          {tr(
            'CHECKOUT.DEPOSIT.PREVIEW.WARNING',
            'Please pay attention to enter your unique reference to your transaction. If the reference is blank or wrong, the transaction will be declined and you will need to enter the correct reference and try again.'
          )}
        </WarningMessageWrapper>
      )}

      {successUrl ? (
        <Button
          type='button'
          color='primary'
          onClick={handleRedirect}
          text={tr('CHECKOUT.BUTTONS.CLOSE', 'Close')}
          data-test='button-back'
        />
      ) : null}
    </BankwirePreviewWrapper>
  )
}
